<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('ticketaction_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{ item['ticket'].name }} - {{ $t('ticket.ticketaction') }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-ticketaction-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.date') }}</strong></td>
              <td>
                  {{ formatDateTime(item['date'], 'long') }}
              </td>
              <td><strong>{{ $t('global.createdby') }}</strong></td>
              <td>
                  <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('ticket.actiontype') }}</strong></td>
              <td>
                <v-icon left v-if="item['type'].public">mdi-eye</v-icon>
                <v-icon left v-else>mdi-eye-off</v-icon>
                <span v-if="language == 'fr'">{{ item['type'].namefr }}</span>
                <span v-else>{{ item['type'].name }}</span>

              </td>
              <td><strong>{{ $t('ticket.ticket') }}</strong></td>
              <td>
                  <span v-if="item['ticket']">
                    <span v-if="item['ticket'].priority.intensity >= 300 ">
                      <v-chip
                        class="ma-2"
                        color="error"
                        text-color="white"
                      >
                      <router-link class="routerLink" :to="{ name: 'TicketShow', params: { id:  item['ticket']['@id']}  }">{{item['ticket'].id }}</router-link> 
                      </v-chip>
                    </span>
                    <span v-else >
                      <v-chip
                        class="ma-2"
                      >
                      <router-link class="routerLink" :to="{ name: 'TicketShow', params: { id:  item['ticket']['@id']}  }">{{item['ticket'].id }}</router-link> 
                      </v-chip>
                    </span>
                  </span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.file') }}</strong></td>
              <td colspan="3">
                                    <v-btn
                                        v-if="item['file']"
                                         color="secondary"
                                         class=""
                                         @click="downloadFileByObject(item)"
                                       >
                                         {{ $t('global.download') }}
                                         <v-icon
                                           right
                                           dark
                                         >mdi-download
                                         </v-icon>
                                       </v-btn>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.content') }}</strong></td>
              <td colspan="3" class="tablehtmleditor" v-html="item['content']"></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Ticketaction';

export default {
  name: 'TicketactionShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('ticketaction', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('ticketaction', ['find']),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('ticketaction', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
